import { type ComponentType, type ReactNode } from 'react';
import { createElement, useEffect, useState } from 'react';
import Dialog from '@/components/dialog';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { DialogSlice } from '@/redux/dialog';

const dialogs = (() => {
  const dialogs = import.meta.glob<ComponentType<string>>('@/dialogs/**/*.tsx', {
    eager: true,
    import: 'default',
  });
  return Object.entries(dialogs).reduce<Record<string, ReactNode>>((acc, [filePath, component]) => {
    const fileNameWithExtension = filePath.split('/').pop() || '';
    const fileName = fileNameWithExtension.replace(/\.[^/.]+$/, '');
    acc[fileName] = createElement(component);
    return acc;
  }, {});
})();

export default function DialogDispatcher() {
  const [content, setContent] = useState<ReactNode | null>(null);
  const name = useAppSelector(DialogSlice.selectors.name);
  const position = useAppSelector(DialogSlice.selectors.position);
  const size = useAppSelector(DialogSlice.selectors.size);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (name) setContent(dialogs[name]);
  }, [name]);

  return (
    <Dialog on={!!name} position={position} size={size} onClose={() => dispatch(DialogSlice.actions.closeDialog())}>
      {content}
    </Dialog>
  );
}
